import { LngLatBounds } from 'mapbox-gl'
import { Feature, Polygon } from 'geojson'
import { match } from 'ts-pattern'
import { polygon } from '@turf/helpers'

interface MaxBoundsResult {
  maxBounds: LngLatBounds | null
  maxBoundsPolygon: Feature<Polygon> | null
}

export const createMaxBounds = (maxBoundsData: {
  northeast: {
    latitude: number
    longitude: number
  }
  southwest: {
    latitude: number
    longitude: number
  }
}): MaxBoundsResult => {
  const maxBounds = match(maxBoundsData)
    .when(
      (maxBounds) => maxBounds !== undefined && maxBounds !== null,
      (maxBounds) =>
        new LngLatBounds([
          [maxBounds.southwest.longitude, maxBounds.southwest.latitude],
          [maxBounds.northeast.longitude, maxBounds.northeast.latitude],
        ]),
    )
    .otherwise(() => null)

  const maxBoundsPolygon = match(maxBounds)
    .when(
      (maxBounds) => maxBounds !== undefined && maxBounds !== null,
      (maxBounds) => {
        const maxBoundsPolygon = polygon([
          [
            [maxBounds.getSouthWest().lng, maxBounds.getSouthWest().lat],
            [maxBounds.getSouthWest().lng, maxBounds.getNorthEast().lat],
            [maxBounds.getNorthEast().lng, maxBounds.getNorthEast().lat],
            [maxBounds.getNorthEast().lng, maxBounds.getSouthWest().lat],
            [maxBounds.getSouthWest().lng, maxBounds.getSouthWest().lat],
          ],
        ])
        maxBoundsPolygon.id = 'max-bounds-polygon'
        return maxBoundsPolygon
      },
    )
    .otherwise(() => null)

  return {
    maxBounds,
    maxBoundsPolygon,
  }
}
